"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _CustomWidgetTags = _interopRequireDefault(require("ContentUtils/constants/CustomWidgetTags"));

var _default = Object.freeze((0, _extends2.default)({}, _CustomWidgetTags.default, {
  CUSTOM_MODULE_MAP: _CustomWidgetTags.default.MAP
}));

exports.default = _default;
module.exports = exports.default;